<div
    class="dropzone"
    [class.is-dragging]="isDraggingOver"
    [class.is-processing]="isProcessing"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">

    <div class="dropzone-prompt" *ngIf="value.length === 0">
        <i class="ph-bold ph-image-square icon-muted icon-20" aria-hidden="true"></i>
        <span class="dropzone-text">
            Paste a screenshot, drag one in, or
            <label class="file-picker-link">
                pick a file
                <input
                    type="file"
                    accept="image/*"
                    multiple
                    [disabled]="!canAddMore"
                    (change)="onFilePicked($event)" />
            </label>
        </span>
    </div>

    <div class="thumbnails" *ngIf="value.length > 0">
        <div
            *ngFor="let url of value; let i = index; trackBy: trackByIndex"
            class="thumbnail">
            <img [src]="url" alt="Screenshot" />
            <button
                type="button"
                class="thumbnail-remove"
                aria-label="Remove screenshot"
                (click)="onRemove(i)">
                <i class="ph-bold ph-x icon-white icon-12" aria-hidden="true"></i>
            </button>
        </div>

        <label class="add-more" *ngIf="canAddMore">
            <i class="ph-bold ph-plus icon-muted icon-16" aria-hidden="true"></i>
            <input
                type="file"
                accept="image/*"
                multiple
                (change)="onFilePicked($event)" />
        </label>
    </div>

    <div class="status-row" *ngIf="isProcessing">
        <i class="ph-bold ph-circle-notch icon-muted icon-14 spinning" aria-hidden="true"></i>
        Processing image…
    </div>

    <div class="error-row" *ngIf="errorMessage">
        <i class="ph-bold ph-warning-circle icon-error icon-14" aria-hidden="true"></i>
        {{ errorMessage }}
    </div>
</div>
